// @flow
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withStyles } from "@material-ui/core/styles";
import HelpIcon from "@material-ui/icons/Help";
import { Modal, Backdrop, Fade, IconButton } from "@material-ui/core";

import { showMessage } from "containers/Snackbar/duck";
import * as securitySelectors from "containers/Security/selectors";

import {
  fetchRoot,
  fetchTopic,
  updateTopic,
  addNewTopic,
  search,
  setTab,
  setPageUrl,
  resetPageUrl,
} from "./duck";
import * as s from "./selectors";
import HelpCard from "./components/HelpCard";
import type { HelpPage } from "./types";

const styles = (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    margin: "32px",
    outline: "none",
    width: "70%",
    maxHeight: "80%",
    overflowY: "auto",
    top: "30px",
    position: "absolute",
  },
  closeIcon: {
    position: "absolute",
    top: "10px",
    right: "30px",
    height: "50px",
    width: "50px",
    color: "white",
    cursor: "pointer",
  },
});

class HelpModal extends Component<HelpPage> {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      topicKey: null,
    };
  }

  handleOpen = () => {
    const { pageUrl } = this.props;
    this.setState({ openModal: true, topicKey: pageUrl });
  };

  handleClose = () => {
    this.setState({ openModal: false, topicKey: null });
  };

  redirect = (url) => {
    const urlSplits = url.split("/");
    this.setState({ topicKey: urlSplits[urlSplits.length - 1] });
  };

  render() {
    const {
      by_key,
      root,
      fetchRoot,
      fetchTopic,
      selectedTab,
      isSearching,
      searchResults,
      search,
      setTab,
      showMessage,
      userRoles,
      classes,
    } = this.props;
    const { topicKey, openModal } = this.state;

    const url = "";
    let dto, loading, action, updateTopic, addNewTopic;
    if (topicKey === null || topicKey.length === 0) {
      dto = root.get("dto");
      loading = root.get("loading");
      action = fetchRoot;
      updateTopic = undefined;
      addNewTopic = undefined;
    } else {
      dto = by_key.getIn([topicKey, "dto"]);
      loading = by_key.getIn([topicKey, "loading"]);
      action = () => fetchTopic(topicKey);
      updateTopic = this.props.updateTopic;
      addNewTopic = this.props.addNewTopic;
    }

    return (
      <div>
        <IconButton aria-label="help" onClick={this.handleOpen}>
          <HelpIcon color="primary" />
        </IconButton>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openModal}
          onClose={this.handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <div>
            <div className={classes.closeIcon} onClick={this.handleClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <div className={classes.modal}>
              <Fade in={openModal}>
                <div className={classes.paper}>
                  <div>
                    <HelpCard
                      topicKey={topicKey}
                      dto={dto}
                      loading={loading}
                      action={action}
                      updateTopic={updateTopic}
                      addNewTopic={addNewTopic}
                      search={search}
                      setTab={setTab}
                      redirect={this.redirect}
                      selectedTab={selectedTab}
                      isSearching={isSearching}
                      searchResults={searchResults}
                      showMessage={showMessage}
                      url={url}
                      isAdmin={userRoles.isAdmin()}
                      isModal
                    />
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: Object, props: Object) =>
  createStructuredSelector({
    root: s.getRoot,
    by_key: s.getByKey,
    selectedTab: s.getSelectedTab,
    isSearching: s.isSearching,
    searchResults: s.getSearchResults,
    userRoles: securitySelectors.getUserRoles,
    pageUrl: s.getPageUrl,
  });

function mapDispatchToProps(dispatch: any) {
  return bindActionCreators(
    {
      fetchRoot,
      fetchTopic,
      updateTopic,
      addNewTopic,
      search,
      setTab,
      showMessage,
      setPageUrl,
      resetPageUrl,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(HelpModal));
